module.exports = __webpack_public_path__ + "static/media/logout.c3d2bfcc.svg";